import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFullScreenExit = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#0f1826",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M1.5 14.5L6.7 9.29999M2.8 9.29999H6.7V13.2M13.2 6.7L9.3 6.7L9.3 2.8M9.3 6.7L14.5 1.5",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgFullScreenExit;
